import { render } from "./UnprocessableEntityErrorModal.vue?vue&type=template&id=8b72d82e"
const script = {}

import "./UnprocessableEntityErrorModal.vue?vue&type=style&index=0&id=8b72d82e&lang=css"

import exportComponent from "/home/time/IdeaProjects/mektep-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__